module.exports = __webpack_public_path__ + "static/media/automated-payroll.f0cfb7ce.png";